module.exports = __webpack_public_path__ + "static/media/map.dc7a722a.svg";